<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right"
				v-if="modal.type=='add'||modal.type=='up'||modal.type=='view'" ref="refForm" :model="modalInfo"
				:label-width="110">
				<Row :gutter="24" style="margin-bottom: 7px;">
					<Col span=24>
					<FormItem label="发票代码" prop="InvoiceCode">
						<Input :disabled="modal.canInput" v-model="modalInfo.InvoiceCode" placeholder="发票代码"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 7px;">
					<Col span=24>
					<FormItem label="发票号码" prop="InvoiceNumber">
						<Input :disabled="modal.canInput" v-model="modalInfo.InvoiceNumber" placeholder="发票号码"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=24>
					<FormItem label="发票类型" prop="InvoiceType">
						<!-- 0-未知；1-支付宝；2-微信；3-威富通；4-农行商户；50-非商户分界值；100-互联互通 -->
						<Select :disabled="modal.canInput" placeholder="发票类型" v-model="modalInfo.InvoiceType">
							<Option :value='1'>普通发票</Option>
							<Option :value='2'>增值税专用发票</Option>
							<Option :value='255'>其他</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 7px;">
					<Col span=24>
					<FormItem label="开票总金额(元)" prop="InvoiceAmount">
						<Input :disabled="true" v-model="modalInfo.InvoiceAmount" placeholder="开票总金额"></Input>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row :gutter="24" style="margin-bottom: 7px;">
					<Col span=24>
					<FormItem label="开票订单" prop="selectedListOrder">
						<Input :disabled="true" type="textarea" v-model="modalInfo.selectedListOrder" placeholder="开票订单"></Input>
					</FormItem>
					</Col>
				</Row> -->
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">取消</Button>
				<Button type="success" size="large" @click="modalOk('add')">开票</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			return {
				modal: {
					Title: "事件添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				//添加会员model
				modalInfo: {
					//Id
					Id: 0,
					InvoiceCode: '',
					InvoiceNumber: '',
					InvoiceType: 1
				},

				/******分割线********/
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},

				//校验字段
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					InvoiceCode: [{
						required: true,
						message: '发票代码',
						trigger: 'blur',
					}],
					InvoiceNumber: [{
						required: true,
						message: '发票号码',
						trigger: 'blur',
					}],
					InvoiceType: [{
						required: true,
						message: '发票类型',
						trigger: 'change',
						type: 'number'
					}],
				},
			};
		},

		methods: {
			//打开新增会员
			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = "开票";
					_this.modal.type = "add";
					_this.$refs.refForm.resetFields()
					_this.modalInfo = {
						Id: params.Id,
						CouponCost: params.CouponCost,
						InvoiceCode: '',
						InvoiceNumber: '',
						InvoiceType: 1,
						selectedListOrder: params.selectedListOrder
					}
				}
				_this.modal.ifShow = true
			},

			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
			//添加
			addAndUp: function(type) {
				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("开票" + type + "----" + valid)
					if (valid) {
						let parms = this.modalInfo
						_this.$axios.post(webapi.base_api_url + "/Order/BillInvoice", parms, {}).then(
							res => {
								console.log("开票")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success('开票成功');
									_this.$emit('handleSubmit');
									_this.modalOk("cancle")
								} else {
									this.$Message.error(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},

			/**********图片组件方法*************/
			//上传文件
			uploadSuccess: function(response, file, fileList) {
				console.log("上传文件成功")
				this.modalInfo.CertFile = response.Data
				//console.log(response)
			},
			//上传文件error
			uploadError: function(response, file, fileList) {
				this.$Message.error("上传文件失败")
			},
			//上传文件检查
			uploadBefore: function(file) {
				// if (this.formInline.FileVersion == '') {
				// 	this.$Message.error("请填写文件版本号")
				// 	return false;
				// }
			},

			formatError: function(file, fileList) {
				this.$Message.error("文件格式为.p12")
			},
		},
		mounted() {

		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
				OperatortypeList: 'typeList',
			})
		}
	}
</script>

<style>
</style>
